import Handlebars from 'hbs';

import HomeRepair from './homeRepair';
import SaLogin from './saLogin'

import Component from './component';

/* Templates */

export default class BespokeFlipColourChange extends Component {

    /* Constructor */
    constructor() {

        super();

        const _this = this;

        _this.init();

    }


    init() {

        const _this = this;

        _this.frontGlassSelectedColour = "";
        _this.rearGlassSelectedColour = "";


       
       
        
        //$('.bespoke-flip-banner.banner-container .s-btn-cta').off('click').on('click', function(event){

        //$('#bespoke-flip-banner .st-feature-benefit-banner__cta a').off('click').on('click', function(event){
        $('#bespoke-banner .btn-container a.s-btn-cta').off('click').on('click', function(event){    

            event.preventDefault();

            

            $("#troubleshooting-guide").html('');
            $('#troubleshooting-guide').hide();
            $('#repair-solutions').html('');
            $('#repair-solutions').hide();
            $('#repair-request-form').hide();
            $('#care-plus-repair').hide();
            $('#cheil-static-app').hide();
            $('#bespoke-model-selector').show();
            $('.bespoke-flip-colour-picker-wrapper').hide();
            _this.scrollTo('#bespoke-model-selector');
            // do this next
            // $('.bespoke-flip-colour-picker-wrapper').show();
            // _this.scrollTo('.bespoke-flip-colour-picker-wrapper');
            //$('#products-section').hide();
            

        });

        //FLIP 3 JOURNEY IS THE SAME
        $('#device-flip-3').off('click').on('click', function(event){
            $('#bespoke-model-selector').hide();
            $('.bespoke-flip-colour-picker-wrapper.flip-3')[0].reset();
            $('.bespoke-flip-colour-picker-wrapper.flip-4')[0].reset();
            $('.bespoke-flip-colour-picker-wrapper.flip-3 .bfcc-step2').hide();
            $('.bespoke-flip-colour-picker-wrapper.flip-3 .bfcc-step3').hide();
            $('.bespoke-flip-colour-picker-wrapper.flip-3').show();
            
            _this.scrollTo('.bespoke-flip-colour-picker-wrapper.flip-3');
        });

        //FLIP 4 JOURNEY IS NEW
        $('#device-flip-4').off('click').on('click', function(event){
            $('#bespoke-model-selector').hide();
            $('.bespoke-flip-colour-picker-wrapper.flip-3')[0].reset();
            $('.bespoke-flip-colour-picker-wrapper.flip-4')[0].reset();
            $('.bespoke-flip-colour-picker-wrapper.flip-4 .bfcc-step2').hide();
            $('.bespoke-flip-colour-picker-wrapper.flip-4 .bfcc-step3').hide();
            $('.bespoke-flip-colour-picker-wrapper.flip-4').show();
            _this.scrollTo('.bespoke-flip-colour-picker-wrapper.flip-4');
        });
        


        /** This Anchor link is triggered from troubleshooter.js file when the page is accessed through hash url mobilecareplus **/ 

        $('#care-plus-anchor-link').off('click').on('click', function(event) {    

            event.preventDefault();
            $('#care-plus-anchor-link').hide();
            _this.scrollTo('#mobile-care-banner');

         });


        $('.bespoke-flip-colour-picker-wrapper .bfcc-step1 .s-btn-cta').off('click').on('click', function(event){

            event.preventDefault();
            //$('.bespoke-flip-colour-picker-wrapper .bfcc-step2').show();
            //_this.scrollTo('.bespoke-flip-colour-picker-wrapper .bfcc-step2');

            if ($('.bespoke-flip-colour-picker-wrapper.flip-4').css('display') == 'block'){
                $('.bespoke-flip-colour-picker-wrapper.flip-4 .bfcc-step2').show();
                _this.scrollTo('.bespoke-flip-colour-picker-wrapper.flip-4 .bfcc-step2');
            } else {
                $('.bespoke-flip-colour-picker-wrapper.flip-3 .bfcc-step2').show();
                _this.scrollTo('.bespoke-flip-colour-picker-wrapper.flip-3 .bfcc-step2');
            }

        });


        /*$('input[name=front-glass]:checked', '#bespoke-colour-picker').change(function(){

            $('.bespoke-flip-colour-picker-wrapper .bfcc-ste2 .c-error').hide();

        });*/


        $('.bespoke-flip-colour-picker-wrapper .bfcc-step2 .s-btn-cta').off('click').on('click', function(event){

            event.preventDefault();
            _this.validateFrontGlassColourSelection();

        });


        /*$('input[name=rear-glass]:checked', '#bespoke-colour-picker').change(function(){

            $('.bespoke-flip-colour-picker-wrapper .bfcc-ste3 .c-error').hide();

        });*/


        $('.bespoke-flip-colour-picker-wrapper .bfcc-step3 .s-btn-cta').off('click').on('click', function(event){

            event.preventDefault();
            _this.validateRearGlassColourSelection();
            
        });


        /*if (_this.isBespoke != "undefined") {

            $('.bespoke-flip-colour-picker-wrapper').show();
            _this.scrollTo('.bespoke-flip-colour-picker-wrapper');

        }*/


    }


    validateFrontGlassColourSelection()  {

        const _this = this;

        let frontGlassSelectedColour = $('input[name=front-glass]:checked').val();

        if (typeof frontGlassSelectedColour !== 'undefined') {

            _this.frontGlassSelectedColour = frontGlassSelectedColour;


            if ($('.bespoke-flip-colour-picker-wrapper.flip-4').css('display') == 'block'){
                $('.bespoke-flip-colour-picker-wrapper.flip-4 .bfcc-step2 .c-error').hide();
                $('.bespoke-flip-colour-picker-wrapper.flip-4 .bfcc-step3 .c-error.no-panel-selected').hide();
                $('.bespoke-flip-colour-picker-wrapper.flip-4 .bfcc-step3').show();
                _this.scrollTo('.bespoke-flip-colour-picker-wrapper.flip-4 .bfcc-step3');
            } else {
                $('.bespoke-flip-colour-picker-wrapper.flip-3 .bfcc-step2 .c-error').hide();
                $('.bespoke-flip-colour-picker-wrapper.flip-3 .bfcc-step3 .c-error.no-panel-selected').hide();
                $('.bespoke-flip-colour-picker-wrapper.flip-3 .bfcc-step3').show();
                _this.scrollTo('.bespoke-flip-colour-picker-wrapper.flip-3 .bfcc-step3');
            }

        } else {

            if ($('.bespoke-flip-colour-picker-wrapper.flip-4').css('display') == 'block'){

                $('.bespoke-flip-colour-picker-wrapper.flip-4.flip-4 .bfcc-step2 .c-error').show();
                _this.scrollTo('.bespoke-flip-colour-picker-wrapper.flip-4 .bfcc-step2');

            } else {

                $('.bespoke-flip-colour-picker-wrapper.flip-3 .bfcc-step2 .c-error').show();
                _this.scrollTo('.bespoke-flip-colour-picker-wrapper.flip-3 .bfcc-step2');


            }

            //alert('got here');

        }

        

    }


    validateRearGlassColourSelection()  {

        const _this = this;

        _this.validateFrontGlassColourSelection();

        let rearGlassSelectedColour = $('input[name=rear-glass]:checked').val();

        if (typeof rearGlassSelectedColour !== 'undefined') {

            _this.rearGlassSelectedColour = rearGlassSelectedColour;

            if (_this.rearGlassSelectedColour == "Rear-NO" &&  _this.frontGlassSelectedColour == "Front-NO") {

                $('.bespoke-flip-colour-picker-wrapper .bfcc-step3 .c-error.no-panel-selected').show();

            } else {

                $('.bespoke-flip-colour-picker-wrapper .bfcc-step3 .c-error.no-panel-selected').hide();
                $('.bespoke-flip-colour-picker-wrapper .bfcc-step3 .c-error').hide();
                _this.getAWSServerSessionCookie();

            }

        } else {

            if ($('.bespoke-flip-colour-picker-wrapper.flip-4').css('display') == 'block'){

                $('.bespoke-flip-colour-picker-wrapper.flip-4 .bfcc-step3 .c-error').show();
                _this.scrollTo('.bespoke-flip-colour-picker-wrapper.flip-4 .bfcc-step3');

            } else {

                $('.bespoke-flip-colour-picker-wrapper.flip-3 .bfcc-step3 .c-error').show();
                _this.scrollTo('.bespoke-flip-colour-picker-wrapper.flip-3 .bfcc-step3');

            }



            

        }

    }

    

    /** Before sending PDList request to AWS Server send initial data to AWS server and get 
    the session cookie for forther requests to avoid XSS requests **/


    getAWSServerSessionCookie() {

        const _this = this;
        // Add the lucid outcode to session ...
        let caseId = _this.getCaseId();
        let tsOutcome = {};
        tsOutcome['lucidRef'] = caseId;
        tsOutcome['symptomCode1'] = 'L9';
        tsOutcome['symptomCode2'] = '03';
        tsOutcome['symptomCode3'] = '01';
        tsOutcome['warrantyException'] = 'VOID1';

        var form = new FormData();
        form.append('caseID', caseId);
        form.append('defect1', 'L9');
        form.append('defect2', '03');
        form.append('defect3', '01');
        form.append('damageRef', 'VOID1');


        //Add troubleshooter ref to maintenance message
       //$('.maintenance .mm-lucidref').html(caseId);

        for (var value of form.values()) {
            _this.doLog(value);
        }

        var host = window.state.apihost;

        var path =  "/uk/repair-booking/";

        var url = host + path + "igspn.php";
        
        var settings = {
            url: url,
            data: form,
            processData: false,
            contentType: false,
            dataType: 'json',
            type: "POST"
        }

        $.ajax(settings).done(function (response) {

            if (response.success == true) {

                tsOutcome['tsSessionRef'] = response.reference;
                //console.log(JSON.stringify(tsOutcome));
                window.state.tsoutcome = tsOutcome;
                window.state.ismaintenanceflagon = response.show_maintenance_message;

                /** Preselect mobile category and products */
                window.state.category = "mobile";
                window.state.product = "Smartphones";
                window.state.selectedservice = "BESPOKE";
                window.state.selectedFlipColour =  _this.frontGlassSelectedColour +" / "+_this.rearGlassSelectedColour
                $('.bespoke-flip-colour-picker-wrapper').hide();
                    
                _this.showSamsungMembersCTA();
            }
            

        }).fail(function() { 

            console.log('TSS fail');

        });
    }


    showSamsungMembersCTA() {

        var $this = this;

        var saLogin = {};
        saLogin = new SaLogin();
        

        if (window.location.host != 'supportrepair.samsung.com') {

            saLogin.isUserLoggedIn().done(function(data) {
                
                
                if (window.state.isUserLoggedIn) {

                    $('#repair-request-form').show();
                    var homeRepair = {};
                    homeRepair = new HomeRepair();
                    $this.scrollTo('#repair-request-form');

                    saLogin.getAccountDetails();


                } else {

                    $('#sa-login').show();
                    $this.scrollTo('#sa-login', 10);
                    saLogin.events();

                }

            });

        } else {


            $('#sa-login').show();
            $this.scrollTo('#sa-login', 10);
            saLogin.events();

        }
    
    }


    getCaseId() {

        let dt = new Date();
        let year  = dt.getFullYear();
        let month = (dt.getMonth() + 1).toString().padStart(2, "0");
        let day   = dt.getDate().toString().padStart(2, "0");
        let hours = dt.getHours().toString().padStart(2, "0");
        let minutes = dt.getMinutes().toString().padStart(2, "0");
        let milliseconds = dt.getMilliseconds().toString().padStart(3, "0");
        return year + month + day + hours + minutes + milliseconds;
    }


    getParam(param) {

        var pageURL = window.location.search.substring(1);
        var URLVariables = pageURL.split('&');

        // main.doLog('Query string values:');

        for (var i = 0; i < URLVariables.length; i++) {
            var queryString = URLVariables[i].split('=');

            // main.doLog('Key: ' + queryString[0] + ', Value:  ' + queryString[1]);

            if (queryString[0] == param) {
                return queryString[1];
            }
        }

    }

 
    scrollTo(element) {

        var stepsSummaryHeight = ($('.floating-navigation').hasClass('floating-navigation--fixed')) ? $('.steps-wrapper').outerHeight()+20 : 20;
        
        stepsSummaryHeight += ($('.summary-wrapper').is(":visible"))? $('.summary-wrapper').outerHeight():0;

        var currentPos = $(element).position().top - stepsSummaryHeight;

        //var currentPos= $(element).position().top;
        setTimeout(function(){
            $("html, body").animate({scrollTop:currentPos},500)
        }, 500);

    }

}
